import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Typography,

} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { AllocateButton,GoToDashboardButton } from "../../../Global_Component/GlobalButtonComponent";

const rows = [
  { id: 1, name: "Savorybites", appNo: "01234", date: "24/01/24", industry: "Fitness", mobile: "+966563919298", status: "Safe" },
  { id: 2, name: "Bab assalam", appNo: "01234", date: "24/01/24", industry: "Food", mobile: "+966563919298", status: "Doubtful" },
  { id: 3, name: "Fourr", appNo: "01234", date: "24/01/24", industry: "Cosmeceutical", mobile: "+966563919298", status: "Critical" },
  { id: 2, name: "Bab assalam", appNo: "01234", date: "24/01/24", industry: "Food", mobile: "+966563919298", status: "Doubtful" },
  { id: 1, name: "Savorybites", appNo: "01234", date: "24/01/24", industry: "Fitness", mobile: "+966563919298", status: "Safe" },
  { id: 2, name: "Bab assalam", appNo: "01234", date: "24/01/24", industry: "Food", mobile: "+966563919298", status: "Doubtful" },
  { id: 3, name: "Fourr", appNo: "01234", date: "24/01/24", industry: "Cosmeceutical", mobile: "+966563919298", status: "Critical" },
  { id: 2, name: "Bab assalam", appNo: "01234", date: "24/01/24", industry: "Food", mobile: "+966563919298", status: "Doubtful" },
];

const statusColors = {
  Safe: "#4CAF50",
  Doubtful: "#FFA000",
  Critical: "#D32F2F",
};

const ApprovedApplications = () => {
  return (
    <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", overflowX: "auto" }}>
      <Typography variant="body1" color="initial" sx={{color:"black",fontWeight:"600",m:1}}>Approved Application</Typography>
      <Table sx={{ minWidth: "1200px" }}>
        <TableHead sx={{ bgcolor: "#F6F8FA" }}>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Company Name</TableCell>
            <TableCell>App No.</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Industry</TableCell>
            <TableCell>Mobile Number</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={row.id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell sx={{ display: "flex", alignItems: "center" }}>
                <Avatar sx={{ bgcolor: "#E3F2FD", width: 40, height: 40 }}>{row.name[0]}</Avatar>
                <span style={{ marginLeft: 10 }}>{row.name}</span>
              </TableCell>
              <TableCell>{row.appNo}</TableCell>
              <TableCell>{row.date}</TableCell>
              <TableCell>{row.industry}</TableCell>
              <TableCell>{row.mobile}</TableCell>
              <TableCell sx={{ color: statusColors[row.status] }}>{row.status}</TableCell>
              <TableCell>
                <AllocateButton />
                <GoToDashboardButton />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ApprovedApplications;
